import {
  createAccountDeletionFrontendPlugin,
  type FrontendPlugin,
} from '@xhubio-saas/core-frontend/kernel'
import { createEmailLogFrontendPlugin } from '@xhubio-saas/core-frontend/plugin-email-log'
import {
  createEmailOutboxFrontendPlugin,
  EMAIL_DISPATCH_SETTINGS_ROUTE,
} from '@xhubio-saas/core-frontend/plugin-email-outbox'
import { createGovCredentialsFrontendPlugin } from '@xhubio-saas/core-frontend/plugin-gov-credentials'
import {
  localesBg as logAuditLocalesBg,
  localesCs as logAuditLocalesCs,
  localesDe as logAuditLocalesDe,
  localesEn as logAuditLocalesEn,
  localesEs as logAuditLocalesEs,
  localesFr as logAuditLocalesFr,
  localesHu as logAuditLocalesHu,
  localesIt as logAuditLocalesIt,
  localesNl as logAuditLocalesNl,
  localesPl as logAuditLocalesPl,
  localesPt as logAuditLocalesPt,
  localesRo as logAuditLocalesRo,
} from '@xhubio-saas/core-frontend/plugin-log-audit'
import { onboardingYamlMessages } from '@xhubio-saas/core-frontend/plugin-onboarding-yaml'
import {
  localesBg as rolesLocalesBg,
  localesCs as rolesLocalesCs,
  localesDe as rolesLocalesDe,
  localesEn as rolesLocalesEn,
  localesEs as rolesLocalesEs,
  localesFr as rolesLocalesFr,
  localesHu as rolesLocalesHu,
  localesIt as rolesLocalesIt,
  localesNl as rolesLocalesNl,
  localesPl as rolesLocalesPl,
  localesPt as rolesLocalesPt,
  localesRo as rolesLocalesRo,
} from '@xhubio-saas/core-frontend/plugin-roles'
import { createSecurityFrontendPlugin } from '@xhubio-saas/core-frontend/plugin-security'
import {
  localesBg as subscriptionLocalesBg,
  localesCs as subscriptionLocalesCs,
  localesDe as subscriptionLocalesDe,
  localesEn as subscriptionLocalesEn,
  localesEs as subscriptionLocalesEs,
  localesFr as subscriptionLocalesFr,
  localesHu as subscriptionLocalesHu,
  localesIt as subscriptionLocalesIt,
  localesNl as subscriptionLocalesNl,
  localesPl as subscriptionLocalesPl,
  localesPt as subscriptionLocalesPt,
  localesRo as subscriptionLocalesRo,
} from '@xhubio-saas/core-frontend/plugin-subscription'
import {
  bg as usageLocalesBg,
  cs as usageLocalesCs,
  de as usageLocalesDe,
  en as usageLocalesEn,
  es as usageLocalesEs,
  fr as usageLocalesFr,
  hu as usageLocalesHu,
  it as usageLocalesIt,
  nl as usageLocalesNl,
  pl as usageLocalesPl,
  pt as usageLocalesPt,
  ro as usageLocalesRo,
} from '@xhubio-saas/core-frontend/plugin-usage'
import {
  localesBg as userLocalesBg,
  localesCs as userLocalesCs,
  localesDe as userLocalesDe,
  localesEn as userLocalesEn,
  localesEs as userLocalesEs,
  localesFr as userLocalesFr,
  localesHu as userLocalesHu,
  localesIt as userLocalesIt,
  localesNl as userLocalesNl,
  localesPl as userLocalesPl,
  localesPt as userLocalesPt,
  localesRo as userLocalesRo,
} from '@xhubio-saas/core-frontend/plugin-user'
import {
  localesBg as apiKeyLocalesBg,
  localesCs as apiKeyLocalesCs,
  localesDe as apiKeyLocalesDe,
  localesEn as apiKeyLocalesEn,
  localesEs as apiKeyLocalesEs,
  localesFr as apiKeyLocalesFr,
  localesHu as apiKeyLocalesHu,
  localesIt as apiKeyLocalesIt,
  localesNl as apiKeyLocalesNl,
  localesPl as apiKeyLocalesPl,
  localesPt as apiKeyLocalesPt,
  localesRo as apiKeyLocalesRo,
} from '@xhubio-saas/frontend-plugin-api-key'
import { de as peppolLocalesDe, en as peppolLocalesEn } from '@xhubio-saas/frontend-plugin-peppol'
import {
  bg as invoiceLocalesBg,
  cs as invoiceLocalesCs,
  de as invoiceLocalesDe,
  en as invoiceLocalesEn,
  es as invoiceLocalesEs,
  fr as invoiceLocalesFr,
  hu as invoiceLocalesHu,
  it as invoiceLocalesIt,
  nl as invoiceLocalesNl,
  pl as invoiceLocalesPl,
  pt as invoiceLocalesPt,
  ro as invoiceLocalesRo,
} from '@xhubio-saas/invoice-frontend/plugin-invoice-api'
import {
  localesBg as logInvoiceLocalesBg,
  localesCs as logInvoiceLocalesCs,
  localesDe as logInvoiceLocalesDe,
  localesEn as logInvoiceLocalesEn,
  localesEs as logInvoiceLocalesEs,
  localesFr as logInvoiceLocalesFr,
  localesHu as logInvoiceLocalesHu,
  localesIt as logInvoiceLocalesIt,
  localesNl as logInvoiceLocalesNl,
  localesPl as logInvoiceLocalesPl,
  localesPt as logInvoiceLocalesPt,
  localesRo as logInvoiceLocalesRo,
} from '@xhubio-saas/invoice-frontend/plugin-log-invoice'
import {
  localesBg as pdfLocalesBg,
  localesCs as pdfLocalesCs,
  localesDe as pdfLocalesDe,
  localesEn as pdfLocalesEn,
  localesEs as pdfLocalesEs,
  localesFr as pdfLocalesFr,
  localesHu as pdfLocalesHu,
  localesIt as pdfLocalesIt,
  localesNl as pdfLocalesNl,
  localesPl as pdfLocalesPl,
  localesPt as pdfLocalesPt,
  localesRo as pdfLocalesRo,
} from '@xhubio-saas/pdf-frontend/plugin-pdf'
import {
  AcceptInvitationPageWithProviders,
  AcceptOwnershipTransferPageWithProviders,
  ApiKeysPageWithProviders,
  BillingPageWithProviders,
  ChangelogPageWithProviders,
  CookieSettingsPageWithProviders,
  EmailDispatchSettingsPageWithProviders,
  EmailLogSettingsPageWithProviders,
  GovCredentialsSettingsPageWithProviders,
  InvoiceConversionPageWithProviders,
  InvoiceFromPdfPageWithProviders,
  InvoiceValidationPageWithProviders,
  LegalSettingsPageWithProviders,
  LogAuditPageWithProviders,
  LogInvoicePageWithProviders,
  PdfTemplateListV2PageWithProviders,
  PeppolSettingsPageWithProviders,
  PeppolTransmissionsPageWithProviders,
  RoleDetailPageWithProviders,
  RoleListPageWithProviders,
  SecuritySettingsPageWithProviders,
  SellerProfilePageWithProviders,
  SettingsAccountPageWithProviders,
  SettingsEmailPageWithProviders,
  SettingsNotificationsPageWithProviders,
  SettingsSystemPageWithProviders,
  UserDetailPageWithProviders,
  UserListPageWithProviders,
  UserProfileEditPageWithProviders,
  VerifactuSettingsPageWithProviders,
  VerifyEmailChangePageWithProviders,
} from './app.pages'
import { withConsentGuard } from './components/withConsentGuard'
import { verifactuLocalesDe, verifactuLocalesEn } from './locales/verifactuLocales'
import { PdfTemplateEditorV2Page } from './pages/PdfTemplateEditorV2Page'
import { SubscriptionRedirect, UsageRedirect } from './pages/protected/billing/legacyRedirect'
import { DashboardPage } from './pages/protected/DashboardPage'
import { AuditActivityWidget } from './pages/protected/dashboard/AuditActivityWidget'
import { TodayUsageWidget } from './pages/protected/dashboard/TodayUsageWidget'
import { UsageDashboardWidget } from './pages/protected/dashboard/UsageDashboardWidget'

const ConsoleDashboardPage = withConsentGuard(DashboardPage)

// ═══════════════════════════════════════════════════════════════════════════
// Plugin Registration
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Application Plugins
 *
 * Register your frontend plugins here. Each plugin can add:
 * - Navigation items
 * - Dashboard widgets
 * - Settings tabs
 * - Routes
 * - Quick actions
 * - Translations
 *
 * Note: requiredEntitlement should always be set for proper RBAC access control.
 * Entitlements are defined in the corresponding kernel-plugin (e.g., kernel-plugin-api-key).
 */
/**
 * Absolute URL of the backend-served OpenAPI docs (Scalar UI at `/docs`).
 * Resolved from runtime config → build-time env → relative `/docs`. The
 * sidebar entry links here directly and opens it in a new browser tab.
 */
const OPENAPI_DOCS_URL = (() => {
  const runtimeApi = window.__RUNTIME_CONFIG__?.API_URL?.replace(/\/+$/, '')
  const buildApi = import.meta.env.VITE_API_URL?.replace(/\/+$/, '')
  const apiUrl = runtimeApi || buildApi || ''
  return `${apiUrl}/docs`
})()

export const plugins: FrontendPlugin[] = [
  // Loeschfrist-Streifen aus dem Kern (Plan CORE 09-25/08 S2): ueber jeder geschuetzten Seite,
  // solange eine Kontoloeschung beantragt ist — Datum und Resttage vom Server, Widerruf mit einem
  // Klick. Ohne Recht, Texte im Kernel-Buendel; ersetzt die nie montierte App-Kopie `DeletionBanner`.
  createAccountDeletionFrontendPlugin(),
  // Quick Actions (Cmd+K palette) — navigation shortcuts to the main
  // console pages. Labels reuse the existing (already-translated in all
  // locales) navigation labelKeys; entitlements mirror the nav entries so
  // an action only appears when the user may reach the page.
  {
    name: '@xhubio-saas/saas-invoice-api-frontend/plugin-quick-actions',
    version: '1.0.0',
    quickActions: [
      {
        // One entry for plan, quota and usage (plan API 2026-10-11/02) — replaces „goto-usage" and
        // „goto-subscription"; the gate is the page's (`billing:usage:read`).
        id: 'goto-billing',
        labelKey: 'common:billingPage.nav.title',
        icon: 'CreditCard',
        href: '/billing',
        requiredEntitlement: 'billing:usage:read',
      },
      {
        id: 'goto-invoice-conversion',
        labelKey: 'invoiceConversion.nav.title',
        icon: 'ArrowRightLeft',
        href: '/invoice-conversion',
        requiredEntitlement: 'invoice-outbound:invoice:generate',
      },
      {
        id: 'goto-api-keys',
        labelKey: 'apiKey.nav.title',
        icon: 'KeyRound',
        href: '/api-keys',
        requiredEntitlement: 'api-key:api-key:read',
      },
      {
        id: 'goto-pdf-templates',
        labelKey: 'pdf.templates.title',
        icon: 'FileType',
        href: '/pdf/v2/templates',
        requiredEntitlement: 'pdf:template:read',
      },
      {
        id: 'goto-log-invoice',
        labelKey: 'logInvoice.nav.title',
        icon: 'FileText',
        href: '/log-invoice',
        requiredEntitlement: 'invoice-outbound:log:read',
      },
      {
        id: 'goto-log-audit',
        labelKey: 'logAudit.nav.title',
        icon: 'ClipboardList',
        href: '/log-audit',
        requiredEntitlement: 'audit:log:read',
      },
      {
        id: 'goto-users',
        labelKey: 'user.nav.title',
        icon: 'Users',
        href: '/users',
        requiredEntitlement: 'members:member:read',
      },
      {
        id: 'goto-roles',
        labelKey: 'roles.settings.tab',
        icon: 'ShieldCheck',
        href: '/settings/roles',
        requiredEntitlement: 'rbac:role:read',
      },
      {
        id: 'goto-settings',
        labelKey: 'common:common.myAccount',
        icon: 'UserCog',
        href: '/settings',
      },
      {
        id: 'goto-system',
        labelKey: 'common:settings.system.tab',
        icon: 'Settings',
        href: '/system',
      },
      {
        id: 'goto-changelog',
        labelKey: 'common:settings.system.changelogTitle',
        icon: 'ScrollText',
        href: '/changelog',
      },
      {
        id: 'goto-cookie-settings',
        labelKey: 'common:cookieConsent.footer.cookieSettings',
        icon: 'Cookie',
        href: '/settings/cookies',
      },
      {
        id: 'goto-dashboard',
        labelKey: 'common:dashboard.nav.title',
        icon: 'LayoutDashboard',
        href: '/dashboard',
      },
    ],
  },

  // Core Navigation Items
  {
    name: '@xhubio-saas/webapp-core-navigation',
    version: '1.0.0',
    // Nutzungs-Dashboard: EIN full-size Widget auf dem Kernel-/dashboard
    // (DashboardGrid rendert registrierte Widgets; keine eigene Route nötig).
    // Der Widget-Container setzt die Überschrift (titleKey), das Widget
    // liefert Untertitel, Zeitraum-Wahl, Chart und Summen.
    dashboardWidgets: [
      {
        // Ohne titleKey: Das Widget beschriftet sich selbst mit dem GEWÄHLTEN
        // Zeitraum (dashboardRange.ts). Der WidgetContainer kann nur einen
        // festen Titel setzen, und „Heute" wäre bei 30 Tagen falsch.
        id: 'today-usage',
        size: 'small',
        order: 5,
        component: TodayUsageWidget,
      },
      {
        id: 'usage-dashboard',
        titleKey: 'dashboard.widget.title',
        size: 'large',
        order: 10,
        component: UsageDashboardWidget,
      },
      {
        // System-Aktivität aus dem Audit-Log (audit.getActivityStats) —
        // gleiche Chart-Sprache wie das Nutzungs-Widget; nur sichtbar mit
        // Audit-Leserecht (wie der Nav-Eintrag der Audit-Seite).
        id: 'audit-activity',
        titleKey: 'dashboard.widget.activity',
        size: 'full',
        order: 20,
        component: AuditActivityWidget,
        requiredEntitlement: 'audit:log:read',
      },
    ],
    navigation: [
      {
        // Dashboard — erster Sidebar-Eintrag (Gruppe main, vor allen anderen
        // Gruppen) und zugleich die Startseite nach Login (layout.defaultRoute).
        id: 'dashboard',
        labelKey: 'common:dashboard.nav.title',
        icon: 'LayoutDashboard',
        href: '/dashboard',
        order: 10,
        group: 'main',
      },
      {
        // „System" der Organisation (Versionen, E-Mail-Protokoll,
        // Rechtliches). Das Persoenliche liegt am Avatar („Mein Konto",
        // `/settings`); hier stand bis 2026-09-25 „Einstellungen" in der
        // Gruppe „Einstellungen". `prefix`: auch die Unterseiten
        // `/system/...` markieren den Eintrag.
        id: 'system',
        labelKey: 'common:settings.system.tab',
        icon: 'Settings',
        href: '/system',
        activeMatch: 'prefix',
        order: 40,
        group: 'settings',
      },
      {
        // Änderungsprotokoll — letzter Eintrag der letzten Gruppe (= ganz
        // unten in der Hauptsidebar). Vorher eine eingeklappte Card auf
        // Einstellungen → System.
        id: 'changelog',
        labelKey: 'common:settings.system.changelogTitle',
        icon: 'ScrollText',
        href: '/changelog',
        order: 60,
        group: 'settings',
      },
    ],
    routes: [
      {
        // Die Console-Startseite (Seitenkopf + `.dashboard-calm`) ersetzt den
        // Fallback des Kernels: createApp hängt seinen eigenen DashboardPage
        // nur ein, wenn kein Plugin `dashboard` liefert. Die Widgets kommen
        // weiter über `dashboardWidgets` (useDashboardWidgets in der Seite).
        path: '/dashboard',
        component: ConsoleDashboardPage,
        layout: 'protected',
      },
      {
        path: '/settings/account',
        component: SettingsAccountPageWithProviders,
        layout: 'protected',
        breadcrumb: {
          labelKey: 'settings.account.tab',
        },
      },
      {
        path: '/system',
        component: SettingsSystemPageWithProviders,
        layout: 'protected',
        breadcrumb: {
          labelKey: 'settings.system.tab',
        },
      },
      {
        path: '/changelog',
        component: ChangelogPageWithProviders,
        layout: 'protected',
        breadcrumb: {
          labelKey: 'settings.system.changelogTitle',
        },
      },
      {
        path: '/settings/cookies',
        component: CookieSettingsPageWithProviders,
        layout: 'protected',
        breadcrumb: {
          labelKey: 'cookieConsent.settings.title',
        },
      },
      {
        path: '/system/legal',
        component: LegalSettingsPageWithProviders,
        layout: 'protected',
        breadcrumb: {
          labelKey: 'settings.legal.tab',
        },
      },
      {
        path: '/settings/email',
        component: SettingsEmailPageWithProviders,
        layout: 'protected',
        breadcrumb: {
          labelKey: 'settings.email.tab',
        },
      },
    ],
    // Cookie-Einstellungen als Tab in der Settings-Navigation (nicht in der
    // Hauptsidebar): öffnet beim Ankommen den Consent-Dialog, die Seite
    // dahinter ist Landeplatz. Vorher ein Button in der „Rechtliches"-Card auf
    // Einstellungen → System. Tab-Label ist das kurze „Cookie"
    // (settings.cookies.tab, app-Locales); Seiten-Copy aus dem Kernel-Bundle
    // (cookieConsent.*, alle 13 Sprachen).
    settingsTabs: [
      {
        id: 'cookies',
        labelKey: 'settings.cookies.tab',
        icon: 'Cookie',
        href: '/settings/cookies',
        order: 60,
        component: CookieSettingsPageWithProviders,
      },
      {
        // Rechtliches (Datenschutz/AGB/Impressum) — wie „Cookie" ein eigener
        // Tab; vorher eine Card auf Einstellungen → System (davor App-Footer).
        id: 'legal',
        labelKey: 'settings.legal.tab',
        icon: 'Scale',
        href: '/system/legal',
        order: 70,
        component: LegalSettingsPageWithProviders,
        // Die Texte des Anbieters, nicht Einstellungen des Nutzers.
        section: 'system',
      },
      {
        // E-Mail-Einstellungen: Marketing-Einwilligung (Opt-In) des Kunden.
        // Gegenstück zum Abmelde-Link in jeder Marketing-Mail
        // (öffentliche Seite /unsubscribe). Reiter heißt „Newsletter" — als
        // „E-Mail" stand er neben „E-Mail-Protokoll", ohne Bezug dazu.
        id: 'email',
        labelKey: 'settings.email.tab',
        icon: 'Mail',
        href: '/settings/email',
        order: 80,
        component: SettingsEmailPageWithProviders,
      },
    ],
  },

  // Subscription Plugin
  {
    name: '@xhubio-saas/core-frontend/plugin-subscription',
    version: '1.0.0',
    // „Billing" (plan API 2026-10-11/02, E6): ONE entry replaces „Abonnement" (here) and „Verbrauch" (analytics).
    // The core SubscriptionPage is no longer mounted; the plugin stays registered for its `subscription`
    // namespace, which the reused pricing cards read (`PricingCard` → useTranslation('subscription')).
    navigation: [
      {
        id: 'billing',
        // 🔴 With `common:` prefix — the label lives in public/locales/*/common.json; without the namespace the
        // sidebar shows the raw id (same as invoice-validation).
        labelKey: 'common:billingPage.nav.title',
        icon: 'CreditCard',
        href: '/billing',
        order: 50,
        group: 'settings',
        // Reihenfolge Organisation: System(40) · Billing(50) · Änderungsprotokoll(60)
        // E7: the page is readable with the usage right (as /usage was); changing the plan needs
        // `billing:subscription:read`, checked on the page.
        requiredEntitlement: 'billing:usage:read',
      },
    ],
    routes: [
      {
        path: '/billing',
        component: BillingPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'billing:usage:read',
        breadcrumb: {
          labelKey: 'common:billingPage.nav.title',
        },
      },
      {
        // E5: old address → /billing?tab=plans, query kept (`umzug=1`, `checkout=…` from the provider's return URL).
        // ⚠️ Same gate as /billing, not the old `billing:subscription:read`: a stricter gate on the redirect would
        // only block someone the target lets in.
        path: '/subscription',
        component: SubscriptionRedirect,
        layout: 'protected',
        requiredEntitlement: 'billing:usage:read',
      },
    ],
    translations: {
      namespace: 'subscription',
      messages: {
        bg: subscriptionLocalesBg,
        cs: subscriptionLocalesCs,
        de: subscriptionLocalesDe,
        en: subscriptionLocalesEn,
        es: subscriptionLocalesEs,
        fr: subscriptionLocalesFr,
        hu: subscriptionLocalesHu,
        it: subscriptionLocalesIt,
        nl: subscriptionLocalesNl,
        pl: subscriptionLocalesPl,
        pt: subscriptionLocalesPt,
        ro: subscriptionLocalesRo,
      },
    },
  },

  // API Key Management Plugin
  {
    name: '@xhubio-saas/frontend-plugin-api-key',
    version: '1.0.0',
    navigation: [
      {
        id: 'API Keys',
        labelKey: 'apiKey.nav.title',
        icon: 'KeyRound',
        href: '/api-keys',
        order: 500,
        group: 'developers',
        requiredEntitlement: 'api-key:api-key:read',
      },
    ],
    routes: [
      {
        path: '/api-keys',
        component: ApiKeysPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'api-key:api-key:read',
        breadcrumb: {
          labelKey: 'apiKey.nav.title',
        },
      },
    ],
    translations: {
      namespace: 'apiKey',
      messages: {
        bg: apiKeyLocalesBg,
        cs: apiKeyLocalesCs,
        de: apiKeyLocalesDe,
        en: apiKeyLocalesEn,
        es: apiKeyLocalesEs,
        fr: apiKeyLocalesFr,
        hu: apiKeyLocalesHu,
        it: apiKeyLocalesIt,
        nl: apiKeyLocalesNl,
        pl: apiKeyLocalesPl,
        pt: apiKeyLocalesPt,
        ro: apiKeyLocalesRo,
      },
    },
    pageHelp: [
      {
        pageId: '/api-keys',
        namespace: 'apiKey',
        sections: [
          {
            id: 'overview',
            titleKey: 'help.overview.title',
            contentKey: 'help.overview.content',
            order: 10,
          },
          {
            id: 'create',
            titleKey: 'help.create.title',
            contentKey: 'help.create.content',
            order: 20,
          },
          {
            id: 'permissions',
            titleKey: 'help.permissions.title',
            contentKey: 'help.permissions.content',
            order: 30,
          },
          {
            id: 'security',
            titleKey: 'help.security.title',
            contentKey: 'help.security.content',
            order: 40,
          },
        ],
      },
    ],
  },

  // Invoice Conversion Plugin
  {
    name: '@xhubio-saas/invoice-frontend/plugin-invoice-api',
    version: '1.0.0',
    navigation: [
      {
        // 🔴 Vor Conversion (order 600): pruefen kommt zuerst. Die Reihenfolge
        // ist eine Produktaussage, keine Kosmetik — wer seine Daten pruefen
        // will, soll nicht erst an einem Konvertierer vorbei.
        //
        // ⚪ Die STARTSEITE bleibt trotzdem /invoice-conversion
        // (`saas.config.ts`, „Conversion-First"): dort erledigt ein neuer
        // Entwickler seinen ersten echten Job. Pruefen kommt, wenn er etwas
        // in der Hand hat.
        id: 'invoice-validation',
        // 🔴 Mit `common:`-Praefix. Die Saetze dieser Seite stehen in
        // `public/locales/*/common.json`; ohne Namensraum sucht i18next im
        // Standard-Namensraum der Seitenleiste und zeigt die rohe Id
        // („invoice-validation", im Browser gesehen 2026-10-02). Die
        // Conversion-Nachbarzeile braucht ihn nicht: ihren Namensraum
        // registriert das Plugin selbst. Vorbild: `common:sidebar.groups.*`
        // im Kernel.
        labelKey: 'common:invoiceValidation.nav.title',
        icon: 'ShieldCheck',
        href: '/invoice-validation',
        order: 590,
        group: 'products',
        // ⚠️ Das grobe Tor wie bei Conversion — bewusst UNVERAENDERT, obwohl
        // die Seite seit dem Umbau auf `parse` abgerechnet wird und nicht mehr
        // auf `create`. Das genaue Recht hiesse `invoice-inbound:invoice:validate`
        // („Validate invoice against schema"); es hier einzusetzen naehme die
        // Seite jedem weg, der sie heute sieht und das Inbound-Recht nicht
        // fuehrt. Ein Zugangstor enger zu ziehen ist eine eigene Entscheidung,
        // kein Nebenprodukt dieses Umbaus. Ein Schluessel ohne
        // `e-invoice:*:*:parse` laeuft in ein 403 mit klarem Text.
        requiredEntitlement: 'invoice-outbound:invoice:generate',
      },
      {
        id: 'invoice-conversion',
        labelKey: 'invoiceConversion.nav.title',
        icon: 'ArrowRightLeft',
        href: '/invoice-conversion',
        order: 600,
        group: 'products',
        requiredEntitlement: 'invoice-outbound:invoice:generate',
      },
      {
        // „E-Rechnung aus PDF" (Plan API 2026-11-01/01, E1): direkt nach der Konvertierung. 🔴 Ohne
        // `requiredEntitlement` (E7): auch Free sieht den Eintrag und auf der Seite den Weg zum Upgrade — ob der
        // Tarif `pdf:invoice:extract` traegt, entscheidet die Seite. `common:`-Praefix wie `invoice-validation`.
        id: 'invoice-from-pdf',
        labelKey: 'common:invoiceFromPdf.nav.title',
        icon: 'FileInput',
        href: '/invoice-from-pdf',
        order: 610,
        group: 'products',
      },
    ],
    routes: [
      {
        path: '/invoice-validation',
        component: InvoiceValidationPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'invoice-outbound:invoice:generate',
        breadcrumb: {
          labelKey: 'common:invoiceValidation.nav.title',
        },
      },
      {
        path: '/invoice-conversion',
        component: InvoiceConversionPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'invoice-outbound:invoice:generate',
        breadcrumb: {
          labelKey: 'invoiceConversion.nav.title',
        },
      },
      {
        // Ohne `requiredEntitlement` wie der Menueeintrag (E7).
        path: '/invoice-from-pdf',
        component: InvoiceFromPdfPageWithProviders,
        layout: 'protected',
        breadcrumb: {
          labelKey: 'common:invoiceFromPdf.nav.title',
        },
      },
    ],
    translations: {
      namespace: 'invoiceConversion',
      messages: {
        bg: invoiceLocalesBg,
        cs: invoiceLocalesCs,
        de: invoiceLocalesDe,
        en: invoiceLocalesEn,
        es: invoiceLocalesEs,
        fr: invoiceLocalesFr,
        hu: invoiceLocalesHu,
        it: invoiceLocalesIt,
        nl: invoiceLocalesNl,
        pl: invoiceLocalesPl,
        pt: invoiceLocalesPt,
        ro: invoiceLocalesRo,
      },
    },
  },

  // Firmendaten (Plan API 2026-11-01/01, E14/E15) — der Absender jeder E-Rechnung aus „E-Rechnung aus PDF".
  // Ein eigener Eintrag statt eines weiteren Menuepunkts im Kern-Plugin: die Seite gehoert zu dieser Funktion.
  {
    name: '@xhubio-saas/saas-invoice-api-frontend/plugin-seller-profile',
    version: '1.0.0',
    navigation: [
      {
        // Lesen darf jedes Mitglied (kein `requiredEntitlement`), schreiben Owner/Admin — die Seite sperrt mit Grund.
        // Reihenfolge Einstellungen: Rollen(20) · Firmendaten(25) · Finanzamt-Zugänge(30) …
        id: 'seller-profile',
        labelKey: 'common:sellerProfile.nav.title',
        icon: 'Building2',
        href: '/settings/company-data',
        order: 25,
        group: 'settings',
      },
    ],
    routes: [
      {
        path: '/settings/company-data',
        component: SellerProfilePageWithProviders,
        layout: 'protected',
        breadcrumb: {
          labelKey: 'common:sellerProfile.nav.title',
        },
      },
    ],
  },

  // OpenAPI Documentation Plugin
  // The Scalar UI is served by the API backend at /docs (auth-gated). The
  // sidebar entry is an external link that opens /docs in a new browser tab —
  // no in-app route needed. Visible whenever the user is logged in; the
  // backend then personalizes the spec per the user's entitlements (or
  // shows an "upgrade" message if entitlements are empty).
  {
    name: '@xhubio-saas/saas-invoice-api-frontend/plugin-api-docs',
    version: '1.0.0',
    navigation: [
      {
        id: 'api-docs',
        labelKey: 'apiDocs.nav.title',
        icon: 'BookOpen',
        href: OPENAPI_DOCS_URL,
        external: true,
        order: 550,
        group: 'developers',
      },
    ],
    translations: {
      namespace: 'apiDocs',
      messages: {
        de: { nav: { title: 'OpenAPI Spec' } },
        en: { nav: { title: 'OpenAPI Spec' } },
      },
    },
  },

  // Usage Overview Plugin
  {
    name: '@xhubio-saas/core-frontend/plugin-usage',
    version: '1.0.0',
    // No nav entry any more — usage lives on /billing (tab „Usage", E6). The plugin stays for its `usage`
    // namespace (dashboard widgets, event type names).
    routes: [
      {
        // E5: old address → /billing?tab=usage, query kept.
        path: '/usage',
        component: UsageRedirect,
        layout: 'protected',
        requiredEntitlement: 'billing:usage:read',
      },
    ],
    translations: {
      namespace: 'usage',
      messages: {
        bg: usageLocalesBg,
        cs: usageLocalesCs,
        de: usageLocalesDe,
        en: usageLocalesEn,
        es: usageLocalesEs,
        fr: usageLocalesFr,
        hu: usageLocalesHu,
        it: usageLocalesIt,
        nl: usageLocalesNl,
        pl: usageLocalesPl,
        pt: usageLocalesPt,
        ro: usageLocalesRo,
      },
    },
  },

  // PDF Template Editor Plugin
  {
    name: '@xhubio-saas/pdf-frontend/plugin-pdf',
    version: '1.0.0',
    navigation: [
      // Nur noch ein Eintrag: die Legacy-v1-Routen sind entfernt, der
      // V2-Editor IST jetzt "PDF Templates".
      {
        id: 'pdf-templates',
        labelKey: 'pdf.templates.title',
        icon: 'FileType',
        href: '/pdf/v2/templates',
        order: 700,
        group: 'products',
        requiredEntitlement: 'pdf:template:read',
      },
    ],
    routes: [
      {
        path: '/pdf/v2/templates',
        component: PdfTemplateListV2PageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'pdf:template:read',
        breadcrumb: {
          labelKey: 'pdf.templates.title',
        },
      },
      {
        path: '/pdf/v2/templates/:id',
        component: PdfTemplateEditorV2Page,
        layout: 'protected',
        requiredEntitlement: 'pdf:template:read',
        breadcrumb: {
          labelKey: 'pdf.templates.edit',
        },
      },
    ],
    translations: {
      namespace: 'pdf',
      messages: {
        bg: pdfLocalesBg,
        cs: pdfLocalesCs,
        de: pdfLocalesDe,
        en: pdfLocalesEn,
        es: pdfLocalesEs,
        fr: pdfLocalesFr,
        hu: pdfLocalesHu,
        it: pdfLocalesIt,
        nl: pdfLocalesNl,
        pl: pdfLocalesPl,
        pt: pdfLocalesPt,
        ro: pdfLocalesRo,
      },
    },
  },

  // Playground Plugin - API Demo
  // {
  //   name: '@xhubio-saas/core-frontend/plugin-playground',
  //   version: '1.0.0',
  //   navigation: [
  //     {
  //       id: 'playground',
  //       labelKey: 'playground.nav.title',
  //       icon: 'Play',
  //       href: '/playground',
  //       order: 10,
  //       group: 'tools',
  //     },
  //   ],
  //   routes: [
  //     {
  //       path: '/playground',
  //       component: PlaygroundPageWithProviders,
  //       layout: 'protected',
  //       breadcrumb: {
  //         labelKey: 'playground.nav.title',
  //       },
  //     },
  //   ],
  //   translations: {
  //     namespace: 'playground',
  //     messages: {
  //       de: playgroundLocalesDe,
  //       en: playgroundLocalesEn,
  //     },
  //   },
  // },

  // Log Audit Plugin - Audit Log Viewer
  {
    name: '@xhubio-saas/core-frontend/plugin-log-audit',
    version: '1.0.0',
    navigation: [
      {
        id: 'log-audit',
        labelKey: 'logAudit.nav.title',
        icon: 'ClipboardList',
        href: '/log-audit',
        order: 410,
        group: 'analytics',
        requiredEntitlement: 'audit:log:read',
      },
    ],
    routes: [
      {
        path: '/log-audit',
        component: LogAuditPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'audit:log:read',
        breadcrumb: {
          labelKey: 'logAudit.nav.title',
        },
      },
    ],
    translations: {
      namespace: 'logAudit',
      messages: {
        bg: logAuditLocalesBg,
        cs: logAuditLocalesCs,
        de: logAuditLocalesDe,
        en: logAuditLocalesEn,
        es: logAuditLocalesEs,
        fr: logAuditLocalesFr,
        hu: logAuditLocalesHu,
        it: logAuditLocalesIt,
        nl: logAuditLocalesNl,
        pl: logAuditLocalesPl,
        pt: logAuditLocalesPt,
        ro: logAuditLocalesRo,
      },
    },
  },

  // Log Invoice Plugin - Invoice Log Viewer
  {
    name: '@xhubio-saas/invoice-frontend/plugin-log-invoice',
    version: '1.0.0',
    navigation: [
      {
        id: 'log-invoice',
        labelKey: 'logInvoice.nav.title',
        icon: 'FileText',
        href: '/log-invoice',
        order: 800,
        group: 'products',
        requiredEntitlement: 'invoice-outbound:log:read',
      },
    ],
    routes: [
      {
        path: '/log-invoice',
        component: LogInvoicePageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'invoice-outbound:log:read',
        breadcrumb: {
          labelKey: 'logInvoice.nav.title',
        },
      },
    ],
    translations: {
      namespace: 'logInvoice',
      messages: {
        bg: logInvoiceLocalesBg,
        cs: logInvoiceLocalesCs,
        de: logInvoiceLocalesDe,
        en: logInvoiceLocalesEn,
        es: logInvoiceLocalesEs,
        fr: logInvoiceLocalesFr,
        hu: logInvoiceLocalesHu,
        it: logInvoiceLocalesIt,
        nl: logInvoiceLocalesNl,
        pl: logInvoiceLocalesPl,
        pt: logInvoiceLocalesPt,
        ro: logInvoiceLocalesRo,
      },
    },
  },

  // Onboarding (YAML-driven post-registration flow).
  // Translations only — the survey has no route of its own anymore. It runs as
  // a modal dialog over the app (OnboardingDialog, mounted by OnboardingGuard);
  // the former `/setup` page is gone. This plugin entry still has to exist,
  // because it is what registers the engine's own button/stepper strings under
  // the `onboardingYaml` namespace — drop it and the dialog renders raw keys.
  // No sidebar entry — purely post-reg, dismissed once
  // onboardingCompleted=true is written to user preferences.
  {
    name: '@xhubio-saas/frontend-plugin-onboarding-yaml',
    version: '1.0.0',
    translations: {
      namespace: 'onboardingYaml',
      // Nav/page/labels come from core-frontend (single source of truth). The
      // former app-local `nav.thanks` is gone with the /setup/thanks route —
      // completing the survey now closes the dialog in place.
      messages: onboardingYamlMessages,
    },
  },

  // Roles & Permissions Plugin.
  {
    name: '@xhubio-saas/core-frontend/plugin-roles',
    version: '1.0.0',
    // Roles is a top-level "Einstellungen" sidebar entry (not a settings tab) so
    // its page keeps the full-width layout instead of replacing the tab bar.
    // The /settings/roles route below renders the page.
    navigation: [
      {
        id: 'roles',
        labelKey: 'roles.settings.tab',
        icon: 'ShieldCheck',
        href: '/settings/roles',
        order: 20,
        group: 'settings',
        requiredEntitlement: 'rbac:role:read',
      },
    ],
    routes: [
      {
        path: '/settings/roles',
        component: RoleListPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'rbac:role:read',
        breadcrumb: { labelKey: 'roles.settings.tab' },
      },
      {
        path: '/settings/roles/:roleId',
        component: RoleDetailPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'rbac:role:read',
        breadcrumb: {
          labelKey: 'roles.detail.breadcrumb',
          parent: '/settings/roles',
        },
      },
    ],
    translations: {
      namespace: 'roles',
      messages: {
        bg: rolesLocalesBg,
        cs: rolesLocalesCs,
        de: rolesLocalesDe,
        en: rolesLocalesEn,
        es: rolesLocalesEs,
        fr: rolesLocalesFr,
        hu: rolesLocalesHu,
        it: rolesLocalesIt,
        nl: rolesLocalesNl,
        pl: rolesLocalesPl,
        pt: rolesLocalesPt,
        ro: rolesLocalesRo,
      },
    },
  },

  // Users / Team Plugin — invite users, manage members + their roles.
  {
    name: '@xhubio-saas/core-frontend/plugin-user',
    version: '1.0.0',
    navigation: [
      {
        id: 'users',
        labelKey: 'user.nav.title',
        icon: 'Users',
        href: '/users',
        order: 10,
        group: 'settings',
        requiredEntitlement: 'members:member:read',
      },
    ],
    routes: [
      {
        path: '/users',
        component: UserListPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'members:member:read',
        breadcrumb: { labelKey: 'user.nav.title' },
      },
      {
        // 🔴 `:userId`, nicht `:memberId`: der Wert ist die Nutzer-Id
        // (`members.list` liefert `id: user.id`, `members.get` nimmt
        // `{ userId }`). Die Route ist app-intern — kein API-Vertrag, keine
        // Deeplinks ausserhalb dieser Datei und `app.pages.tsx`.
        path: '/users/:userId',
        component: UserDetailPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'members:member:read',
        breadcrumb: { labelKey: 'user.detail.tab.profile', parent: '/users' },
      },
      {
        // 🔴 Das Profilformular — der einzige Ort mit „E-Mail aendern".
        // Begruendung und die Falle mit `targetUserId`: `app.pages.tsx`,
        // `UserProfileEditPageWithProviders`.
        //
        // ⚪ Dasselbe Leserecht wie die Detailseite, **nicht** das Adminrecht:
        // wer sein EIGENES Profil pflegt, ist kein Admin. Die Grenze zum
        // fremden Profil zieht der Server (`requireRoleAdminRaw`, sobald
        // `targetUserId` von der eigenen Id abweicht) — sie hier zu
        // verdoppeln sperrte die Selbstbedienung aus.
        path: '/users/:userId/edit',
        component: UserProfileEditPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'members:member:read',
        breadcrumb: { labelKey: 'user.detail.tab.profile', parent: '/users' },
      },
      {
        path: '/invite/accept',
        component: AcceptInvitationPageWithProviders,
        layout: 'public',
      },
      {
        path: '/verify-email-change',
        component: VerifyEmailChangePageWithProviders,
        layout: 'public',
      },
      {
        path: '/ownership-transfer/accept',
        component: AcceptOwnershipTransferPageWithProviders,
        layout: 'public',
      },
    ],
    translations: {
      namespace: 'user',
      messages: {
        bg: userLocalesBg,
        cs: userLocalesCs,
        de: userLocalesDe,
        en: userLocalesEn,
        es: userLocalesEs,
        fr: userLocalesFr,
        hu: userLocalesHu,
        it: userLocalesIt,
        nl: userLocalesNl,
        pl: userLocalesPl,
        pt: userLocalesPt,
        ro: userLocalesRo,
      },
    },
  },

  // Peppol network plugin — settings + transmissions log.
  // Peppol is not generally available yet, so it is hidden from the UI: the
  // sidebar `navigation` entry and the Settings → Peppol tab (`settingsTabs`)
  // are intentionally omitted. The routes below stay registered (reachable only
  // via direct URL for testing); restore the `navigation` + `settingsTabs`
  // arrays to bring Peppol back into the menus.
  {
    name: '@xhubio-saas/frontend-plugin-peppol',
    version: '1.0.0',
    routes: [
      {
        path: '/peppol/transmissions',
        component: PeppolTransmissionsPageWithProviders,
        layout: 'protected',
        breadcrumb: { labelKey: 'peppol.transmissions.title' },
      },
      {
        path: '/settings/peppol',
        component: PeppolSettingsPageWithProviders,
        layout: 'protected',
        breadcrumb: { labelKey: 'peppol.settings.title' },
      },
    ],
    translations: {
      namespace: 'peppol',
      messages: {
        de: peppolLocalesDe,
        en: peppolLocalesEn,
      },
    },
  },

  // ─────────────────────────────────────────────────────────────────────────
  // Sicherheits-Tab (Zwei-Faktor-Anmeldung) — seit 2026-08-29 REGISTRIERT.
  //
  // 🔴 Er war es bis dahin bewusst NICHT: die Kette „2FA einschalten ⇒
  // naechste Anmeldung abgewiesen ⇒ dauerhaft ausgesperrt" war real. Alle
  // drei Ursachen von damals sind gemessen behoben — der Kommentar bleibt
  // stehen, weil die Gegenprobe sonst niemand mehr findet:
  //
  // 1. better-auth loescht im Anmelde-Haken die Sitzung, wenn
  //    `user.twoFactorEnabled` gesetzt ist, und verlangt eine Rueckfrage.
  //    ⇒ gilt weiterhin, ist jetzt aber BEANTWORTBAR (Punkt 3).
  // 2. Geprueft wird gegen better-auths eigene Tabelle. Die gibt es seit
  //    core-backend `drizzle/0007_nice_firestar.sql`
  //    (`kernel_auth_two_factor`, Adapter-Mapping `kernel/auth/config.ts`).
  //    Der Router ruft seit 1.68.0 durchgehend better-auth
  //    (`enableTwoFactor`/`verifyTOTP`/`disableTwoFactor`), nicht mehr den
  //    eigenen `totp_secret`-Zweig.
  // 3. Die Anmeldemaske kennt die Rueckfrage: `useSignIn` liefert
  //    `twoFactorRequired`, und `pages/auth/LoginPage.tsx` beantwortet sie
  //    ueber `useVerifyTwoFactor` (TOTP ODER Sicherungscode). 🔴 Diese App
  //    ersetzt die Kernel-Maske ueber `auth.components.login` — die
  //    gleichlautende Behandlung in `core-frontend/LoginForm.tsx` erreicht
  //    invoice-api deshalb NICHT und musste hier ein zweites Mal stehen.
  //
  // Gemessen am 2026-08-29 an einer frischen DB: enable → verify →
  // Anmelde-Rueckfrage → Sitzung laeuft durch.
  //
  // ⚪ Kein Entitlement: `auth.twoFactor.*` ist `protectedProcedure` und
  // user-scoped. Ein Zugangsschutz, den der Betreiber erst freischalten muss,
  // waere das falsche Produkt.
  //
  // 🔵 `labelKey` wird ueber den Standard-Namensraum aufgeloest, nicht ueber
  // den Plugin-Namensraum. Die Fabrik liefert `security.tab`; diese App
  // benennt ihre Reiter durchgehend `settings.<x>.tab`
  // (`public/locales/<lng>/common.json`, wie `settings.emailLog.tab`) —
  // deshalb der Ueberschreib-Griff, dasselbe Muster wie bei den
  // Finanzamt-Zugaengen darunter. Ohne ihn zeigt der Reiter seine Id.
  // ─────────────────────────────────────────────────────────────────────────
  (() => {
    const plugin = createSecurityFrontendPlugin({
      settingsComponent: SecuritySettingsPageWithProviders,
    })
    return {
      ...plugin,
      settingsTabs: plugin.settingsTabs?.map((tab) => ({
        ...tab,
        labelKey: 'settings.security.tab',
      })),
    }
  })(),

  // E-Mail-Protokoll: welche System-Mails die Organisation verlassen haben.
  // Router + Entitlement (`email:logs:read`, Kernel → Owner/Administrator)
  // standen seit Langem; gelesen hat sie kein Frontend. Der Tab macht den
  // Ausgang sichtbar — Support-Rückfragen wie „Ich habe keine Einladung
  // bekommen" enden sonst bei einem Entwickler mit DB-Zugang.
  //
  // 🔴 Der Seiteninhalt kommt aus dem Plugin-Namensraum `emailLog`, den die
  // Fabrik selbst mitbringt (12 Sprachen) — hier ist nichts nachzutragen. Das
  // TAB-LABEL dagegen löst `SettingsTabs` über `useTranslation()` auf, also im
  // `common`-Bundle: `settings.emailLog.tab` steht deshalb in
  // `public/locales/<lng>/common.json`, wie `settings.cookies.tab`.
  //
  // 🔵 Die Fabrik registriert `/settings/email-log`; in dieser App liegt das
  // Protokoll unter System (`/system/email-log`, die alte Adresse leitet in
  // `saas.config.ts` weiter). Umgelenkt werden Route und Reiter-Ziel.
  (() => {
    const plugin = createEmailLogFrontendPlugin({
      settingsComponent: EmailLogSettingsPageWithProviders,
    })
    const ziel = '/system/email-log'
    return {
      ...plugin,
      routes: plugin.routes?.map((route) => ({ ...route, path: ziel })),
      // `section` steht ab core-frontend 5.24 auch in der Fabrik; hier
      // ausdruecklich, weil die Seite der App davon abhaengt.
      settingsTabs: plugin.settingsTabs?.map((tab) => ({
        ...tab,
        href: ziel,
        section: 'system' as const,
      })),
    }
  })(),

  // E-Mail-Freigabe: zurückgehaltene Mails ansehen, freigeben, verwerfen — und je Versandkategorie schalten, ob
  // überhaupt gehalten wird (Issue API 2026-10-02 `ia-fe-ohne-postausgang-seite`). Router `email.outbox.*` und Rechte
  // liegen im Kernel; IA-BE meldet dazu die eigene Kategorie `report` an, ihre Texte stehen in
  // `saas.config.ts` → `languages.overrides.emailOutbox`.
  //
  // Seite `/email-freigabe`, Menüeintrag und Hinweisstreifen kommen unverändert aus der Fabrik (Recht
  // `email:outbox:release` an Route, Eintrag und Streifen). Umgelenkt wird nur der Reiter „E-Mail-Versand":
  // der Schalter gilt für die ganze Organisation (`organization:settings:update`) und liegt deshalb unter System
  // (`/system/email-dispatch`, die Fabrik-Adresse leitet in `saas.config.ts` weiter) — dasselbe Muster wie beim
  // E-Mail-Protokoll darüber. `settingsComponent` gibt der Seite den Einstellungsrahmen mit Reitern.
  (() => {
    const plugin = createEmailOutboxFrontendPlugin({
      settingsComponent: EmailDispatchSettingsPageWithProviders,
    })
    const ziel = '/system/email-dispatch'
    return {
      ...plugin,
      routes: plugin.routes?.map((route) =>
        route.path === EMAIL_DISPATCH_SETTINGS_ROUTE ? { ...route, path: ziel } : route
      ),
      // Der Menüeintrag kommt aus der Fabrik mit `order: 92`; das Änderungsprotokoll (60) muss der letzte Eintrag der
      // Gruppe bleiben (tests/app.plugins.test.ts). 55 setzt die Freigabe zwischen die IA-Einträge 50 und 60.
      navigation: plugin.navigation?.map((item) => ({ ...item, order: 55 })),
      settingsTabs: plugin.settingsTabs?.map((tab) => ({
        ...tab,
        href: ziel,
        section: 'system' as const,
      })),
    }
  })(),

  // Government Credentials Plugin - Finanzamt-Zugänge.
  // Gov Credentials is a top-level "Einstellungen" sidebar entry (not a settings
  // tab) so its page keeps the full-width layout. The factory only ships a
  // settingsTab + route, so we graft on a navigation entry and drop the tab.
  (() => {
    const plugin = createGovCredentialsFrontendPlugin({
      settingsComponent: GovCredentialsSettingsPageWithProviders,
    })
    return {
      ...plugin,
      navigation: [
        {
          id: 'gov-credentials',
          labelKey: 'govCredentials.nav.title',
          icon: 'Shield',
          href: '/settings/gov-credentials',
          order: 30,
          group: 'settings',
          requiredEntitlement: 'gov-credentials:credential:read',
        },
      ],
      settingsTabs: undefined,
    }
  })(),

  // VeriFactu (ES) — declaración responsable, Aktivierung, offene Registros.
  // Diese App lädt plugin-invoice nicht, es gibt hier also keine
  // Invoice-Settings-Seite, von der aus man die Seite erreichen könnte. Deshalb
  // ein eigener „Einstellungen"-Eintrag wie bei den Finanzamt-Zugängen:
  // Art. 13.2 RD 1007/2023 verlangt, dass die Herstellererklärung *im System*
  // schnell und intuitiv einsehbar ist, und dieses Backend erzeugt spanische
  // Registros. `requiresModule` hält den Eintrag aus den Sidebars aller nicht-
  // spanischen Organisationen heraus (armiert von VerifactuNavGate); die Route
  // selbst bleibt registriert und zeigt für nicht-ES den Hinweis der Seite.
  {
    name: '@xhubio-saas/webapp-verifactu',
    version: '1.0.0',
    navigation: [
      {
        id: 'verifactu',
        requiresModule: 'verifactu',
        labelKey: 'verifactu.nav.title',
        icon: 'FileCheck2',
        href: '/settings/verifactu',
        // Reihenfolge Einstellungen: … Finanzamt-Zugänge(30) · VeriFactu(35) · Einstellungen(40) …
        order: 35,
        group: 'settings',
        // config:update ist das einzige real registrierte Entitlement, das den
        // Kreis richtig zieht (Owner/Administrator): der Schalter ist eine
        // rechtliche Bindung bis zum 31.12., kein Anzeige-Detail.
        requiredEntitlement: 'invoice-outbound:config:update',
      },
    ],
    routes: [
      {
        path: '/settings/verifactu',
        component: VerifactuSettingsPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'invoice-outbound:config:update',
        breadcrumb: { labelKey: 'verifactu.nav.title' },
      },
    ],
    translations: {
      namespace: 'verifactu',
      messages: {
        de: verifactuLocalesDe,
        en: verifactuLocalesEn,
      },
    },
  },

  // ═══════════════════════════════════════════════════════════════════════
  // Geplante Berichte und Alarme (Plan CORE 2026-08-20/04, Welle 4)
  // ═══════════════════════════════════════════════════════════════════════
  //
  // Eigener Plugin-Eintrag statt einer weiteren Zeile im Kern-Settings-Block:
  // Die Übersetzungen gehören zu DIESER Fläche und liegen deshalb in ihrem
  // eigenen Namensraum — genau wie bei VeriFactu.
  //
  // 🔴 `requiredEntitlement` ist bewusst das LESE-Recht: Wer Berichte nur sehen
  // darf, soll den Reiter finden. Ob er einen anlegen darf, entscheidet das
  // Backend an der Mutation (`report:subscription:manage`) — nicht diese Liste.
  // Ein Reiter, der bei fehlendem Schreibrecht ganz verschwindet, macht aus
  // einer Einschränkung ein Rätsel.
  {
    name: '@xhubio-saas/webapp-reports',
    version: '1.0.0',
    routes: [
      {
        path: '/settings/notifications',
        component: SettingsNotificationsPageWithProviders,
        layout: 'protected',
        requiredEntitlement: 'report:subscription:read',
        breadcrumb: { labelKey: 'settings.notifications.tab' },
      },
    ],
    settingsTabs: [
      {
        id: 'notifications',
        // 🔴 `SettingsTabs` löst `labelKey` mit `useTranslation()` OHNE
        // Namensraum auf — also im `common`-Bündel. Ein Schlüssel aus einem
        // eigenen Plugin-Namensraum bliebe unaufgelöst und der Reiter fiele
        // still auf seine Id („notifications") zurück. Die Copy liegt deshalb
        // in `public/locales/<lng>/common.json`, wie bei „E-Mail-Protokoll".
        labelKey: 'settings.notifications.tab',
        icon: 'Bell',
        href: '/settings/notifications',
        order: 90,
        component: SettingsNotificationsPageWithProviders,
        requiredEntitlement: 'report:subscription:read',
      },
    ],
  },
]
